import get from 'lodash/get';
import { PROFILE } from '../../../constants/strings';

export default (fields, errors) => {
  if (!errors) return null;

  // check if we have errors for fields
  const hasErrors = fields.find(item => {
    return get(errors, [get(item, 'fieldName', '')]);
  });

  if (!hasErrors) return null;

  const checkedErrors = [];

  // get translation for error
  Object.keys(errors).forEach(item => {
    const code = get(errors, `[${item}][0].code`);
    const error = get(PROFILE.errors, `[${item}][${code}]`);
    if (error) checkedErrors.push(error);
  });

  return checkedErrors.length ? checkedErrors : null;
};



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/Profile/convertFieldsError.js